import React, { FC } from 'react'

import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import { zIndex } from 'components/designSystem/zIndex'
import { createLocationName } from 'components/page/Landing/LandingView/createLocationName'
import {
  LandingBannerButton,
  LandingBannerPicture,
  LandingBannerTitle,
} from 'components/page/Landing/LandingView/LandingView.styled'
import { indexPath } from 'components/paths'
import {
  ThirdPartyPlace,
  useThirdPartyUrl,
} from 'hooks/temrorary/useThirdPartyUrl'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { isSeriousRelaionship } from '../Special/Special.functions'

export const LandingBannerContent = styled.div`
  border-radius: 10px;
  position: relative;
  padding: 40px;
  line-height: 1.2;
  text-align: center;
  margin: 20px 0;
  overflow: hidden;
  z-index: ${zIndex.background};

  @media (max-width: 640px) {
    padding-top: 20px;
    padding-bottom: 20px;
  }
`

export const LandingJoinBanner: FC = () => {
  const { anotherBannerPhotoUrl, anotherBannerPhotoWebpUrl } =
    useShallowEqualSelector(
      ({
        landingReducer: { anotherBannerPhotoUrl, anotherBannerPhotoWebpUrl },
      }) => ({
        anotherBannerPhotoUrl,
        anotherBannerPhotoWebpUrl,
      })
    )

  const thirdPartyUrl = useThirdPartyUrl(ThirdPartyPlace.joinBanner)

  return (
    <LandingBannerContent>
      <picture>
        <source srcSet={anotherBannerPhotoWebpUrl} type="image/webp" />
        <source srcSet={anotherBannerPhotoUrl} type="image/jpeg" />
        <LandingBannerPicture src={anotherBannerPhotoUrl} />
      </picture>
      <LandingBannerTitle>
        <FormattedMessage
          id="landing.banner.title.communication"
          defaultMessage="Начните общаться прямо сейчас!"
        />
      </LandingBannerTitle>

      {thirdPartyUrl ? (
        <LandingBannerButton
          data-name="landing-join-banner-action"
          href={thirdPartyUrl}
        >
          <FormattedMessage
            id="landing.banner.button.join"
            defaultMessage="Присоединиться"
          />
        </LandingBannerButton>
      ) : (
        <LandingBannerButton
          data-name="landing-join-banner-action"
          to={indexPath}
        >
          <FormattedMessage
            id="landing.banner.button.join"
            defaultMessage="Присоединиться"
          />
        </LandingBannerButton>
      )}
    </LandingBannerContent>
  )
}

const messages = defineMessages({
  lookFor: {
    id: 'landing.banner.lookFor',
    defaultMessage:
      '[{locationPopulation}] человек из {locationName} ищут дружбу и общение на Мамбе',
  },
  seriousLookFor: {
    id: 'landing.banner.lookFor.serious',
    defaultMessage:
      '[{locationPopulation}] человек ищут серьёзные отношения на Мамбе',
  },
})

export const LandingBottomBanner: FC = () => {
  const intl = useIntl()

  const thirdPartyUrl = useThirdPartyUrl(ThirdPartyPlace.bottomRegisterBanner)

  const { seoLocation, bannerPhotoWebpUrl, bannerPhotoUrl } =
    useShallowEqualSelector(
      ({
        landingReducer: { seoLocation, bannerPhotoWebpUrl, bannerPhotoUrl },
      }) => ({
        seoLocation,
        bannerPhotoWebpUrl,
        bannerPhotoUrl,
      })
    )

  const locationName = createLocationName(seoLocation!.location)

  const locationPopulation =
    seoLocation?.usersPopulation && seoLocation.usersPopulation.toLocaleString()

  const { pathname } = useLocation()
  const serious = isSeriousRelaionship(pathname)
  const values = {
    locationPopulation,
    locationName,
  }

  return (
    <LandingBannerContent>
      <picture>
        <source srcSet={bannerPhotoWebpUrl} type="image/webp" />
        <source srcSet={bannerPhotoUrl} type="image/jpeg" />
        <LandingBannerPicture
          src={bannerPhotoUrl}
          alt={
            intl.formatMessage(
              serious ? messages.seriousLookFor : messages.lookFor,
              values
            ) as string
          }
        />
      </picture>
      <LandingBannerTitle>
        {serious ? (
          <FormattedMessage
            id="landing.banner.lookFor.serious"
            values={values}
            defaultMessage="[{locationPopulation}] человек ищут серьёзные отношения на Мамбе"
          />
        ) : (
          <FormattedMessage
            id="landing.banner.lookFor"
            values={values}
            defaultMessage="[{locationPopulation}] человек из {locationName} ищут дружбу и общение на Мамбе"
          />
        )}
      </LandingBannerTitle>

      {thirdPartyUrl ? (
        <LandingBannerButton href={thirdPartyUrl}>
          <FormattedMessage
            id="app.register.to"
            defaultMessage="Зарегистрироваться"
          />
        </LandingBannerButton>
      ) : (
        <LandingBannerButton to={indexPath}>
          <FormattedMessage
            id="app.register.to"
            defaultMessage="Зарегистрироваться"
          />
        </LandingBannerButton>
      )}
    </LandingBannerContent>
  )
}
